import { Permission, TaskPermission } from '@anb/ng-auth';
import { Task } from './tasks';

export const AM_BO_CWBE_R = new TaskPermission(Task.AM_BO_CWBE, Permission.Read); // Read WBE aanvraag
export const AM_BO_CWBE_U = new TaskPermission(Task.AM_BO_CWBE, Permission.Update); //Update WBE aanvraag

export const AM_BO_R_R = new TaskPermission(Task.AM_BO_R, Permission.Read); // Read all aanvraag

export const AM_BO_COG_U = new TaskPermission(Task.AM_BO_COG, Permission.Update); // Correct melding

export const AM_BO_A_C = new TaskPermission(Task.AM_BO_A, Permission.Create); //Create comment
export const AM_BO_A_U = new TaskPermission(Task.AM_BO_A, Permission.Update); //Update comment
export const AM_BO_A_D = new TaskPermission(Task.AM_BO_A, Permission.Delete); //Delete comment

export const AM_BO_BVA_R = new TaskPermission(Task.AM_BO_BVA, Permission.Read); // Bekijk alle

export const AM_BO_BD_R = new TaskPermission(Task.AM_BO_BD, Permission.Read); // Dossier read
export const AM_BO_BD_U = new TaskPermission(Task.AM_BO_BD, Permission.Update); // Dossier Update
export const AM_BO_BD_D = new TaskPermission(Task.AM_BO_BD, Permission.Delete); // Delete draft dossier

export const AM_BO_DUA_D = new TaskPermission(Task.AM_BO_DUA, Permission.Delete); // Delete completed dossier

export const MeldingUpdatePermissions = [AM_BO_CWBE_U.taskPermissionAsString, AM_BO_COG_U.taskPermissionAsString, AM_BO_BD_U.taskPermissionAsString];
